import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Loader from 'modules/common/components/Loader';

import { Wrapper, Select, Text, Icon, Envelop, EnvelopItem } from './DropdownMenu.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const DropdownMenu = ({
  dropdownMenuItemsList,
  dropdownMenuSelectedObj,
  dropdownMenuPlaceholder,
  disabled,
  showLoader,
  handleDropdownMenuChange,
}) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dropdownMenuWrapperRef = useRef(null);

  const hasOnlyOneItem = dropdownMenuItemsList.length === 1;
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isMenuEnvelopOpen, setIsMenuEnvelopOpen] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    if (hasOnlyOneItem && !dropdownMenuSelectedObj.key) {
      handleDropdownMenuChange(dropdownMenuItemsList[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownMenuItemsList]);

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        dropdownMenuWrapperRef.current &&
        dropdownMenuWrapperRef.current.contains(event.target) === false
      )
        setIsMenuEnvelopOpen(false);
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [dropdownMenuWrapperRef]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleMenuSelectClick = () => {
    if (disabled || hasOnlyOneItem) return;

    setIsMenuEnvelopOpen(prevState => !prevState);
  };

  const handleDropdownMenuItemClick = selectedObj => {
    setIsMenuEnvelopOpen(false);
    handleDropdownMenuChange(selectedObj);
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <Wrapper ref={dropdownMenuWrapperRef}>
      <Select
        data-testid="dropdown-menu-select"
        disabled={disabled || hasOnlyOneItem}
        onClick={handleMenuSelectClick}
      >
        <Text data-testid="dropdown-menu-text">
          {dropdownMenuSelectedObj?.name || dropdownMenuPlaceholder}
        </Text>
        {showLoader === false ? (
          <Icon data-testid="dropdown-menu-icon" />
        ) : (
          <Loader data-testid="dropdown-menu-loader" width={14} height={14} thickness={3} />
        )}
      </Select>
      {isMenuEnvelopOpen && (
        <Envelop data-testid="dropdown-menu-envelope">
          {dropdownMenuItemsList.map(menuItem => (
            <EnvelopItem
              data-testid={menuItem.key}
              key={menuItem.key}
              onClick={() => handleDropdownMenuItemClick(menuItem)}
            >
              {menuItem.name}
            </EnvelopItem>
          ))}
        </Envelop>
      )}
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

DropdownMenu.propTypes = {
  dropdownMenuItemsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dropdownMenuSelectedObj: PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
  }).isRequired,
  dropdownMenuPlaceholder: PropTypes.string,
  disabled: PropTypes.bool,
  showLoader: PropTypes.bool,
  handleDropdownMenuChange: PropTypes.func.isRequired,
};

DropdownMenu.defaultProps = {
  dropdownMenuPlaceholder: '',
  disabled: false,
  showLoader: false,
};

export default DropdownMenu;
